export const GET_HOTELS_CONFIG = 'ott/hotels/hotelsConfig/GET_HOTELS_CONFIG';
export const GET_HOTELS_CONFIG_SUCCESS = 'ott/hotels/hotelsConfig/GET_HOTELS_CONFIG_SUCCESS';
export const GET_HOTELS_CONFIG_FAIL = 'ott/hotels/hotelsConfig/GET_HOTELS_CONFIG_FAIL';
